import { useFrame } from "@react-three/fiber";
import { Vector3 } from "three";
import { useHoveredEditHandleStore } from "../../store/hoveredEditHandleStore";

const projected = new Vector3();

// Lives inside <Canvas>: tracks the hovered edit handle's world position and projects it to
// screen/page coordinates every frame, writing the result to the store. Renders no DOM itself —
// R3F's reconciler can't host plain HTML elements (that needs the real react-dom tree), so the
// actual tooltip is rendered by EditHandleTooltipOverlay, mounted outside the Canvas.
const EditHandleTooltipComponent = () => {
    // Selected narrowly, and the setter read non-reactively, so this component doesn't
    // re-render every frame just because its own setScreenPosition() call touches the store.
    const position = useHoveredEditHandleStore((s) => s.position);

    useFrame(({ camera, gl, size }) => {
        if (!position) return;

        projected.copy(position).project(camera);
        const canvasRect = gl.domElement.getBoundingClientRect();
        const x = canvasRect.left + window.scrollX + (projected.x * 0.5 + 0.5) * size.width;
        const y = canvasRect.top + window.scrollY + (1 - (projected.y * 0.5 + 0.5)) * size.height;

        useHoveredEditHandleStore.getState().setScreenPosition({ x, y });
    });

    return null;
};

export default EditHandleTooltipComponent;
